/**
 * CHG-053 REQ-V53-008: 타입별 필드 설정 API 서비스
 */
import api from '../lib/axios';
import type { ApiResponse } from '@maios/shared';

export interface FieldConfigField {
  fieldId: string;
  name: string;
  fieldKey: string;
  fieldType: string;
  description: string | null;
  options: string[] | null;
  defaultValue: string | null;
  isSystem: boolean;
}

export interface FieldConfigItem {
  id: string;
  field: FieldConfigField;
  visibility: 'VISIBLE' | 'HIDDEN' | 'REQUIRED';
  sortOrder: number;
}

export interface FieldConfigSection {
  name: string;
  fields: FieldConfigItem[];
}

export interface FieldConfigResponse {
  issueType: { issueTypeId: string; name: string; icon: string; color: string };
  sections: FieldConfigSection[];
  availableFields: FieldConfigField[];
}

export interface SaveFieldConfigItem {
  fieldId: string;
  visibility: 'VISIBLE' | 'HIDDEN' | 'REQUIRED';
  sortOrder: number;
  sectionName: string;
}

export async function fetchFieldConfig(issueTypeId: string): Promise<FieldConfigResponse> {
  const res = await api.get<ApiResponse<FieldConfigResponse>>(`/admin/issue-types/${issueTypeId}/field-config`);
  return res.data.data!;
}

export async function saveFieldConfig(issueTypeId: string, configs: SaveFieldConfigItem[]): Promise<FieldConfigResponse> {
  const res = await api.put<ApiResponse<FieldConfigResponse>>(`/admin/issue-types/${issueTypeId}/field-config`, { configs });
  return res.data.data!;
}
